import { useEffect } from "react";
import { Group, GroupsState, RECEIVE_GROUPS, SEND_GROUPS } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitGroupsActions } from "./toolkitGroupsStore";

type GroupPayload = {
  baseAvatarURL?: string | null;
  groups?: Group[] | null;
};

export function useToolkitGroupsRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== SEND_GROUPS && action.type !== RECEIVE_GROUPS) {
        return;
      }

      const payload = (action.payload ?? {}) as GroupPayload;
      const nextState: Partial<GroupsState> =
        action.type === SEND_GROUPS
          ? { groups: payload.groups ?? null }
          : {
              baseAvatarURL: payload.baseAvatarURL ?? null,
              groups: payload.groups ?? null,
            };

      toolkitGroupsActions.mergeGroups(nextState);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
